module.exports = {
  buildVersion: "2025.5.0",
  buildDate: 1753812212224,
}